module.exports = __webpack_public_path__ + "img/1.0db42377.png";